import { DeleteButton, DeleteButtonProps } from "react-admin";

// Botão de exclusão padrão do painel: SEMPRE abre o modal de
// confirmação antes de excluir (mutationMode "pessimistic").
// Substitui o padrão anterior do react-admin — excluir na hora com
// "Desfazer" de 4 segundos no toast — que era fácil de acionar sem
// querer. Os textos podem ser sobrescritos por quem usa via props.
export const AppDeleteButton = (props: DeleteButtonProps) => (
  <DeleteButton
    mutationMode="pessimistic"
    confirmTitle="Excluir este registro?"
    confirmContent="Esta ação é definitiva e não pode ser desfeita. Confirmar a exclusão?"
    {...props}
  />
);
